export default {
  title: "light",

  colors: {
    primary: "#00b000",
    secondary: "#f8a200",
    tertiary: "#6B53C6",

    background: {
      primary: "#f4f4f4",
      secondary: "#ffffff",
      textInput: "#ffffff"
    },
    text: "#333",
    tableBorder: "#e0e0e0",
    mapFill: "#efefef",
    mapHover: "#dddddd",
    mapStroke: "#FFF",
    chart: {
      primary: "#00b000",
      secondary: "#f8a200",
      tertiary: "#000000",
      quaternary: "#cccccc"
    },
    textInputBorder: "#eeeeee"
  }
};
